<template>
	<div>
		<loginheader></loginheader>
		<div class="Registcon">
			<div class="Registcon-div">
				<img :src="imageUrl" alt class="Registcon-img" />
				<p class="Registcon-p">{{nickname}}</p>
				<p class="Registcon-p1">注册成功</p>
				<router-link to="/login">
					<p class="Registcon-p2">点击回到首页</p>
				</router-link>
			</div>
		</div>
		<Fotter></Fotter>
	</div>
</template>

<script>
	import loginheader from "../loginheader.vue";
	import Fotter from "../Fotter.vue";

	export default {
		name: "App",
		props: ["flag"],
		components: {
			loginheader,
			Fotter
		},
		data() {
			//这里存放数据
			return {
				info: "",
				nickname: "",
				imageUrl: ""
			};
		},
		created() {
			this.$http
				.post("user/info/", { token: this.$cookies.get("token") })
				.then(res => {
					if (res.body.code == 1) {
						this.info = res.body.data;
						this.nickname = res.body.data.nickname;
						this.imageUrl = res.body.data.avatar;
					}
				});
		}
	};
</script>

<style scoped="scoped">
	.Registcon {
		width: 100%;
		height: auto;
	}

	.Registcon-div {
		width: 150px;
		margin: 175px auto 0;
	}

	.Registcon-img {
		width: 138px;
		height: 138px;
		margin: 0 auto;
	}

	.Registcon-p {
		font-size: 16px;
		text-align: center;
		margin-top: 37px;
	}

	.Registcon-p1 {
		margin-top: 70px;
		text-align: center;
		color: #28a3b1;
		font-size: 16px;
	}

	.Registcon-p2 {
		margin-top: 16px;
		text-align: center;
		color: #28a3b1;
		font-size: 16px;
		margin-bottom: 286px;
	}
</style>



// WEBPACK FOOTER //
// src/components/login/Registration.vue